export default 'M12 0 1 10v14h8v-7a3 3 0 1 1 6 0v7h8V10z';